module.exports = __webpack_public_path__ + "img/task.cd49dae1.png";